import { BoMItemRow, BomItemType } from 'model/Project/BoMItemRow'
import { AnimalScaleFilter } from 'store/Project/ProjectTypes'

export function applyAnimalScaleFilter(
  filter: AnimalScaleFilter,
  row: BoMItemRow,
): boolean {
  if (!filter.enabledFilters || filter.enabledFilters.length === 0) {
    return true
  }

  switch (row.type) {
    case BomItemType.partType:
    case BomItemType.partInstance: {
      return filter.enabledFilters.includes(row.animalScale)
    }
    default:
      return true
  }
}
